import { LeftOutlined } from '@ant-design/icons';
import { PropsWithChildren } from 'react';
import Layers from '../../../../assets/icon/layers.svg?react';
import useLegendStore from '../../../../store/legendStore';
import { IconBox } from '../PointPanel/IconTool';
import styles from './PointLayerMenu.module.scss';

export default function PointLayerMenu({ children }: PropsWithChildren) {
  const showLayerView = useLegendStore((state) => state.showLayerView);
  const setShowLayerView = useLegendStore((state) => state.setShowLayerView);

  const handleCollapseIcon = () => {
    setShowLayerView(!showLayerView);
  };

  return (
    <div className={styles.container}>
      <div
        className={`${styles.panel} ${!showLayerView ? styles.collapsed : ''}`}
      >
        <div className={styles.content}>{children}</div>
      </div>

      <IconBox
        id={'Layer_Overview-Collapsible_Button'}
        data-testid='Layer_Overview-Collapsible_Button'
        className={styles.closeIcon}
        onClick={handleCollapseIcon}
      >
        {showLayerView ? <LeftOutlined /> : <Layers />}
      </IconBox>
    </div>
  );
}
